module.exports = __webpack_public_path__ + "static/media/Icon-Director.d93aeb21.png";